import { Avatar, Divider, Dropdown, Layout, Menu, Typography } from 'antd';
import iomlogo from '../../assets/logo/IOM_UN.svg';

import './styles.css';
import { LogoutOutlined, UserOutlined, MoreOutlined, SettingOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../app/store';
import { logoutUser } from '../../features/auth/authApi';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../features/language/languageSlice';
import LanguageSwitcher from '../language/LanguageSwitcher';
import changepass from '../../assets/changePass_icons.svg';
import logouticon from '../../assets/logout_icons.svg';
import { useNavigate } from 'react-router-dom';
import { Suspense } from 'react';

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = () => {
  const { t, i18n } = useTranslation();
  const { logout } = useAuth();
  const location = useLocation();

  const loginUser = useSelector((state: RootState) => state.auth.loginUser);
  const dispatch = useAppDispatch();
  const language = i18n.language;
  const navigate = useNavigate();
  //const language = useSelector((state: RootState) => state.language.currentLanguage);// Track language in Redux

  // Conditional rendering: Don't show avatar on login or reset password page
  const isUserLogin = location.pathname === '/login' || location.pathname.startsWith('/reset-password');
  const roleName = loginUser?.user?.role_id == 1 ? t("role.super.admin") : loginUser?.user?.role_id == 2 ? t("role.data.manager")
    : loginUser?.user?.role_id == 3 ? t("role.data.collector") : loginUser?.user?.role_id == 4 ? t("role.data.viewer") : '';
  // Extracting initials from the user's name
  const getInitials = (name: string) => {
    return name.split(' ').map((word) => word[0]).join('').toUpperCase();
  };

  // Handle logout function  
  const handleLogout = () => {
    dispatch(logoutUser())
      .unwrap()
      .then(() => {
        logout();
      });
  };

  // Handle language change
  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang); // Change the language using i18next
    dispatch(changeLanguage(lang)); // Dispatch language change action to Redux
    window.location.reload();
  };

  const menu = (
    <Menu style={{ padding: '8px 0', minWidth: '150px' }}>
      <Menu.Item key="changePassword" onClick={(e) => navigate(`/change-password`)} style={{ padding: '10px 20px' }}>
        <img src={changepass} alt="imo" width={20} height={20} style={{ padding: '0 8px', position: 'relative', top: '5px' }} />
        {t('login.change-password.title')}
      </Menu.Item>
      <Divider style={{ margin: '0 0' }} />
      <Menu.Item key="logout" onClick={handleLogout} style={{ padding: '10px 20px' }}>
        <img src={logouticon} alt="imo" width={20} height={20} style={{ padding: '0 8px', position: 'relative', top: '5px' }} />
        {t('header.logout')}
      </Menu.Item>
    </Menu>
  );

  return (


    <Header className="header" style={{ backgroundColor: '#0033A0', color: '#fff', padding: '0 20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <div style={{ marginTop: 26 }}>
          <a onClick={(e) => navigate(`/home`)}><img src={iomlogo} alt="imo" width={210} /></a>
        </div>
        <div style={{ flex: 1, textAlign: 'left' }}>
          <div className='iomName' style={{ width: '230px', margin: '0px 15px' }}>
            <div>{t('header.online.migration')}</div>
            {/* <div>{t('header.data.platform')}</div> */}
          </div>
        </div>

        {/* Language Switcher */}
        <div className='langSwitcher'>
          <LanguageSwitcher
            handleLanguageChange={handleLanguageChange}
            language={language == 'en-US' ? 'en' : language} />
        </div>

        {/* Avatar, Name, Role, and Dropdown */}
        {!isUserLogin && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
              <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Avatar className='avatarPhoto' size="large">
                  {getInitials(loginUser?.user?.name || "Login User")}
                </Avatar>
                <ul className='avatarName'>
                  <li style={{ color: '#fff', fontWeight: 'bold' }}>{loginUser?.user?.name || ''}</li>
                  <li style={{ color: '#ccc', fontSize: '12px' }}>{roleName}</li>
                </ul>
                {/* <MoreOutlined style={{ color: '#fff', fontSize: '20px' }} /> */}
              </div>
            </Dropdown>
          </div>
        )}
      </div>
    </Header>
  );
};

export default AppHeader;